/**
 * Firebase Module Index
 * 
 * This file exports all Firebase-related functionality from a single location,
 * allowing for simpler imports such as:
 * import { initializeNotifications } from '../GlobalModules/Utility/Firebase';
 */

// Re-export everything from FirebaseService
export { default as FirebaseService } from './FirebaseService';
export {
  initializeFirebase,
  setupMessageListener,
  getMessaging,
  getFirebaseApp
} from './FirebaseService';

// Re-export testing utilities
export {
  testFirebaseInit,
  testMessageListener,
  runFullFirebaseTest
} from './test-notifications';

// Export original firebase config functions if needed directly
export {
  requestNotificationPermission,
  onMessageListener
} from './firebase-config';

// Re-export NotificationService functions
export { default as NotificationService } from './NotificationService';
export {
  initializeNotifications,
  setupForegroundNotificationListener,
  initializeAudioOnInteraction
} from './NotificationService';

// Default export of the NotificationService for backward compatibility
export { default } from './NotificationService';
